<article>
    <form [formGroup]="form">
        <ng-container *ngIf="!FromAdmin">
            <mat-form-field>
                <mat-label>Id Cliente</mat-label>
                <input type="text" formControlName="clientid" autocomplete="off" matInput placeholder="Id Cliente">
                <mat-error *ngIf="form.get('idCliente')?.hasError('required')">Este campo es obligatorio</mat-error>
            </mat-form-field>
        </ng-container>

        <mat-form-field>
            <mat-label>Usuario</mat-label>
            <mat-select formControlName="userid">
                <mat-option *ngFor="let servicio of servicios" [value]="servicio.value">
                    {{ servicio.viewValue }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('tipoServicio')?.hasError('required')">Este campo es obligatorio</mat-error>
        </mat-form-field>

        <mat-form-field class="-password">
            <mat-label>Contraseña</mat-label>
            <input [type]="!isHideNew ? 'password' : 'text'" formControlName="password" autocomplete="off" matInput placeholder="Contraseña">
            <mat-icon matSuffix (click)="isHideNew = !isHideNew">{{isHideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-error *ngIf="form.get('password')?.hasError('required')">Este campo es obligatorio</mat-error>
        </mat-form-field>

        <button class="df-primario df-btn-xl" [disabled]="onValidation" (click)="onSubmit()">
            Ingresa aquí
        </button>
    </form>
</article>